import { render } from "./App.vue?vue&type=template&id=0f297634"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0f297634&lang=css"

import exportComponent from "E:\\object\\源制汇产能共享公共服务平台\\boyaokj-enyuan-yuanliancloud-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__